import React from "react";

/**
 * Logo BEVID — écusson surf rétro flatline : soleil couchant à bandes, vague filaire,
 * ruban wordmark Shrikhand. Couleurs = jetons (teal / corail / soleil / sable / encre).
 */
export function BevidBadge({ size = 40, className = "" }) {
  const ink = "var(--ds-text-primary)";
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" className={className} xmlns="http://www.w3.org/2000/svg" aria-label="BEVID" role="img">
      <defs>
        <clipPath id="bevid-disc"><circle cx="60" cy="56" r="44" /></clipPath>
      </defs>
      {/* ombre offset */}
      <circle cx="63" cy="59" r="52" fill={ink} />
      <circle cx="60" cy="56" r="52" fill="var(--ds-brand-sand)" stroke={ink} strokeWidth="3" />
      <g clipPath="url(#bevid-disc)">
        {/* ciel */}
        <rect x="0" y="0" width="120" height="120" fill="var(--ds-accent-veil)" />
        {/* soleil à bandes rétro */}
        <circle cx="60" cy="52" r="26" fill="var(--ds-brand-sun)" stroke={ink} strokeWidth="2.5" />
        <circle cx="60" cy="52" r="18" fill="var(--ds-brand-coral)" />
        {[40, 47, 54, 61].map((y, i) => (
          <rect key={y} x="20" y={y} width="80" height={2 + i} fill="var(--ds-brand-sand)" />
        ))}
        {/* mer */}
        <path d="M-5 78 C 15 70, 30 70, 45 78 S 75 86, 92 78 S 118 70, 130 78 L 130 125 L -5 125 Z" fill="var(--ds-accent)" />
        {/* vague filaire avec écume */}
        <path d="M18 80 c 10 -16 26 -18 36 -6 c 4 5 3 11 -2 14 c 9 -1 15 -8 15 -17 c 0 -9 -6 -15 -13 -17"
          fill="none" stroke="var(--ds-bg-elevated)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M18 80 c 10 -16 26 -18 36 -6 c 4 5 3 11 -2 14 c 9 -1 15 -8 15 -17 c 0 -9 -6 -15 -13 -17"
          fill="none" stroke={ink} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.5" />
        <circle cx="30" cy="92" r="2.5" fill="var(--ds-bg-elevated)" />
        <circle cx="84" cy="96" r="2" fill="var(--ds-bg-elevated)" />
      </g>
      {/* ruban wordmark */}
      <path d="M14 86 l 10 -8 h 72 l 10 8 l -10 8 h -72 z" fill={ink} transform="translate(2.5 2.5)" />
      <path d="M14 86 l 10 -8 h 72 l 10 8 l -10 8 h -72 z" fill="var(--ds-brand-coral)" stroke={ink} strokeWidth="2.5" strokeLinejoin="round" />
      <text x="60" y="91" textAnchor="middle" fontFamily="Shrikhand, cursive" fontSize="15" letterSpacing="1.5" fill="var(--ds-bg-elevated)">BEVID</text>
    </svg>
  );
}

/** Logo complet : écusson + wordmark rétro (ombre offset corail/soleil). */
export default function BevidLogo({ size = 32, showWord = false, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="bevid-logo">
      <BevidBadge size={size} />
      {showWord && <span className="wordmark" style={{ fontSize: size * 0.8 }}>BEVID</span>}
    </span>
  );
}

/** Wordmark seul (en-têtes) — même traitement rétro. */
export function BevidWordmark({ className = "", size = 28 }) {
  return <span className={`wordmark ${className}`} style={{ fontSize: size }} aria-label="BEVID">BEVID</span>;
}
